/**
 * Build-time env. Vite inlines `import.meta.env.VITE_*` into the bundle.
 * Keep secrets out of here — anything VITE_-prefixed ships to the browser.
 */
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
const apiKey = import.meta.env.VITE_API_KEY ?? '';
const stage = import.meta.env.VITE_STAGE ?? 'local';

export const env = {
  apiBaseUrl,
  apiKey,
  stage,
};
